var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: { title: "Session launch before schedule", footer: false },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        }
      }
    },
    [
      _c("div", { staticClass: "px-8 pb-8 w-160 flex flex-col gap-4" }, [
        _c(
          "div",
          [
            _c("BlTextBody2", {
              staticClass: "text-slate-800",
              attrs: { text: "This session is scheduled for:" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex items-center gap-2 mb-4" }, [
          _c("div", { staticClass: "w-25 flex-shrink-0 rounded shadow-md" }, [
            _c(
              "div",
              {
                staticClass:
                  "h-7 flex items-center justify-center rounded-t bg-lime-200"
              },
              [
                _c("BlTextBody2", {
                  staticClass: "text-lime-700",
                  attrs: { text: "Scheduled" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
              },
              [
                _c("BlTextTitle4", {
                  staticClass: "text-lime-700",
                  attrs: {
                    text: _vm.displayDate(_vm.sessionAppointment.date, "DD")
                  }
                }),
                _vm._v(" "),
                _c("BlTextBody2", {
                  staticClass: "text-lime-600",
                  attrs: {
                    text: _vm.displayDate(_vm.sessionAppointment.date, "MMMM")
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-col gap-1 px-2" }, [
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _c("BlIcon", {
                  staticClass: "h-4 w-4",
                  attrs: { icon: "user", color: "slate-6" }
                }),
                _vm._v(" "),
                !_vm.sessionAppointment.user
                  ? _c("BlTextBody2", { attrs: { text: "-" } })
                  : _c("BlTextBody2", {
                      class: { "italic ": !_vm.sessionAppointment.user.name },
                      attrs: {
                        text: _vm.sessionAppointment.user.name || "Deleted user"
                      }
                    })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _c("BlIcon", {
                  staticClass: "h-4 w-4",
                  attrs: { icon: "clock-outline", color: "slate-6" }
                }),
                _vm._v(" "),
                _c("BlTextBody2", {
                  staticClass: "text-slate-800",
                  attrs: {
                    text:
                      _vm.sessionAppointment.start_time_string +
                      " - " +
                      _vm.sessionAppointment.end_time_string
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.sessionAppointment.room
              ? _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c("BlIcon", {
                      staticClass: "h-4 w-4",
                      attrs: { icon: "door", color: "slate-6" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "text-slate-800",
                      attrs: { text: _vm.sessionAppointment.room.name }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("BlTextBody2", {
              staticClass: "text-slate-800",
              attrs: { text: "Are you sure you want to start the session now?" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex items-center justify-end gap-4" },
          [
            _c("BlInputButton", {
              attrs: { type: "plain", label: "Cancel" },
              on: {
                clicked: function($event) {
                  return _vm.$emit("close-modal")
                }
              }
            }),
            _vm._v(" "),
            _c("BlInputButton", {
              attrs: { label: "Proceed" },
              on: {
                clicked: function($event) {
                  return _vm.$emit("on-submit")
                }
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08ddcac1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08ddcac1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/draft/LaunchBeforeTheTimeModal.vue
// module id = null
// module chunks = 